/* eslint-disable react/jsx-props-no-spreading */
import { Boundary, MessageDisplay } from 'components/common';
import { useDocumentTitle, useScrollTop } from 'hooks';
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import firebase from 'firebase/firebase';
import { query, collection, orderBy } from 'firebase/firestore';
import { useCollection } from 'react-firebase-hooks/firestore';
import { useTranslation } from 'react-i18next';
import PlanItem from '../components/PlanItem';

const Plans = () => {
  const { t } = useTranslation();
  useDocumentTitle('Admin - Uilpi');
  useScrollTop();
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  });

  const [plans, isLoadingPlans, errorPlans] = useCollection(
    query(collection(firebase.db, 'plans'), orderBy('position')),
    {
      snapshotListenOptions: { includeMetadataChanges: true }
    }
  );

  return (
    <Boundary>
      <div className="product-admin-header">
        <h3 className="product-admin-header-title">{t('adminPlansMessage')}</h3>
      </div>
      <div className="product-admin-subheader">
        <span>{t('adminPlansParagraph')}</span>
      </div>
      <div className="product-admin-items">
        <div>
          <div className="grid grid-product grid-count-6">
            <div className="grid-col">
              <h5>{t('productTableName')}</h5>
            </div>
            <div className="grid-col grid-col-onlydesktop">
              <h5>{`${t('planTableDuration')} (${t('planTableMonths')})`}</h5>
            </div>
            <div className="grid-col grid-col-onlydesktop">
              <h5>{t('planTableProductsLimit')}</h5>
            </div>
            <div className="grid-col grid-col-onlydesktop">
              <h5>{t('planTablePhotosLimit')}</h5>
            </div>
            <div className="grid-col grid-col-onlydesktop">
              <h5>{t('planTablePrice')}</h5>
            </div>
          </div>
          {errorPlans && <MessageDisplay message={errorPlans} />}
          {plans &&
            !isLoadingPlans &&
            plans.docs.map((plan) => {
              return <PlanItem key={plan.id} id={plan.id} plan={plan.data()} />;
            })}
        </div>
      </div>
    </Boundary>
  );
};

export default withRouter(Plans);
